import React from 'react';
import styled from 'styled-components/macro';

const CrossPieceSchemaDimensions = () => (
  <StyledCrossPieceSchema>
    <StyledDimensionValue>4</StyledDimensionValue>
  </StyledCrossPieceSchema>
);

const StyledCrossPieceSchema = styled.div`
  position: relative;
  grid-row-end: span 1;
  display: grid;
  justify-content: right;
  align-items: center;

  border-top: 1px solid black;
  border-bottom: 1px solid black;
`;

const StyledDimensionValue = styled.div`
  position: absolute;
  right: 0;
  margin-right: 5px;
  font-size: 0.8rem;
`;

export default CrossPieceSchemaDimensions;
